var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9261 15.9262L12.0857 12.0742C13.3792 10.7711 14.1198 9.01911 14.1534 7.18338C14.1869 5.34764 13.5108 3.56978 12.2658 2.22027C11.0209 0.870755 9.3032 0.0536776 7.47072 -0.0606264C5.63824 -0.17493 3.83234 0.422324 2.42935 1.60667C1.02636 2.79101 0.134515 4.47109 -0.0603205 6.29676C-0.255156 8.12244 0.262043 9.9529 1.3835 11.4067C2.50495 12.8604 4.14414 13.8253 5.95948 14.1003C7.77481 14.3753 9.62623 13.9391 11.1279 12.8827L15.0446 16.8135C15.1028 16.8714 15.1719 16.9172 15.2479 16.9484C15.3239 16.9796 15.4052 16.9955 15.4874 16.9952C15.5695 16.9949 15.6508 16.9785 15.7265 16.9468C15.8023 16.9151 15.8711 16.8688 15.929 16.8106C15.9869 16.7523 16.0327 16.6832 16.0639 16.6072C16.0951 16.5313 16.111 16.4499 16.1107 16.3678C16.1104 16.2857 16.094 16.2044 16.0623 16.1286C16.0306 16.0528 15.9843 15.9841 15.9261 15.9262ZM1.24803 7.0903C1.25172 5.94013 1.59615 4.81684 2.23783 3.8623C2.87951 2.90777 3.78966 2.16483 4.85333 1.72723C5.91701 1.28963 7.0865 1.17701 8.21412 1.40365C9.34174 1.6303 10.3769 2.18605 11.1889 3.00064C12.0009 3.81524 12.5533 4.85218 12.7763 5.98052C12.9994 7.10886 12.883 8.27794 12.442 9.34021C12.001 10.4025 11.2551 11.3103 10.2985 11.9489C9.34196 12.5875 8.21759 12.9284 7.06742 12.9284C6.30194 12.9273 5.54418 12.7754 4.83741 12.4814C4.13065 12.1874 3.48872 11.757 2.94832 11.2149C2.40791 10.6727 1.9796 10.0294 1.68786 9.32174C1.39612 8.61403 1.24667 7.85577 1.24803 7.0903Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.d7942f5ff7bb658e710e4f7183b28fb1.svg";
export { ForwardRef as ReactComponent };